import React, { useState } from "react";
import "../css/ActivitiesGallery.css";
// Sample images for each activity (replace with appropriate paths).
import infra1 from "../asset/Infrastructure/_DSC0655.jpg";
import infra2 from "../asset/Infrastructure/_DSC0659.jpg";
import infra3 from "../asset/Infrastructure/_DSC0758.jpg";
import infra4 from "../asset/Infrastructure/_DSC0844.jpg";
import infra5 from "../asset/Infrastructure/_DSC0852.jpg";
import infra6 from "../asset/Infrastructure/_DSC0857.jpg";
import infra7 from "../asset/Infrastructure/_DSC0858.jpg";
import infra8 from "../asset/Infrastructure/_DSC0881.jpg";
import infra9 from "../asset/Infrastructure/_DSC0883.jpg";
import infra10 from "../asset/Infrastructure/_DSC0889.jpg";

import facilities1 from "../asset/Facilities/_DSC0868.jpg";
import facilities2 from "../asset/Facilities/_DSC0876.jpg";

const Activities = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const activities = [
    {
      title: "Infrastructure",
      description:
        "Our campus boasts modern infrastructure, including well-equipped classrooms, advanced laboratories, a resource-rich library, and excellent sports and recreational facilities, creating the perfect environment for learning and growth.",
      images: [
        infra1,
        infra2,
        infra3,
        infra4,
        infra5,
        infra6,
        infra7,
        infra8,
        infra9,
        infra10,
      ],
    },
    {
      title: "Facilities",
      description:
        "We provide top-notch facilities, such as smart classrooms, a fully equipped library, cutting-edge labs, sports amenities, transportation, and extracurricular activity spaces to support the all-round development of our students.",
      images: [facilities1, facilities2],
    },
  ];

  const openImage = (image) => {
    setCurrentImage(image);
    setIsOpen(true);
  };

  const closeImage = () => {
    setIsOpen(false);
    setCurrentImage(null);
  };

  return (
    <div className="activities-container">
      <h1 className="activities-head">Infrastructure</h1>
      <p className="activities-intro">
        "Our campus is designed to provide a conducive environment for holistic
        development and learning. Equipped with state-of-the-art facilities, we
        offer spacious and well-ventilated classrooms, modern laboratories, a
        well-stocked library, and advanced IT infrastructure. Our sports
        facilities promote physical fitness, while dedicated spaces for arts and
        extracurricular activities foster creativity. The campus is complemented
        by eco-friendly initiatives, secure premises, and accessible amenities,
        ensuring a safe and enriching experience for all students."
      </p>
      {activities.map((activity, index) => (
        <div key={index} className="activity-section">
          <h2 className="activity-title">{activity.title}</h2>
          <p className="activity-description">{activity.description}</p>
          <div className="activity-gallery">
            {activity.images.map((image, idx) => (
              <div
                key={idx}
                className="activity-item"
                onClick={() => openImage(image)}
              >
                <img src={image} alt={`${activity.title} ${idx}`} />
              </div>
            ))}
          </div>
        </div>
      ))}

      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
            <img
              className="modal-image"
              src={currentImage}
              alt="Expanded view"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Activities;
